import { useProfile } from '@sdc/auth';
import { ListChecks, Megaphone, Users } from 'lucide-react';
import { useState } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { Splash } from '../components/Splash';
import { AnnouncementsPanel } from './admin/AnnouncementsPanel';
import { PollsPanel } from './admin/PollsPanel';
import { UsersPanel } from './admin/UsersPanel';

type Tab = 'users' | 'announcements' | 'polls';

/** `?bereich=` aus den Links im Schwarzen Brett → Registerkarte. */
const BEREICHE: Record<string, Tab> = { brett: 'announcements', abfragen: 'polls' };

export function AdminPage() {
  const { loading, isAdmin } = useProfile();
  const [params] = useSearchParams();
  const [tab, setTab] = useState<Tab>(() => BEREICHE[params.get('bereich') ?? ''] ?? 'users');

  if (loading) return <Splash label="Berechtigungen werden geprüft …" />;
  // Nur der Sichtbarkeits-Check. Die Autorisierung passiert serverseitig in den
  // Functions – der Client kann sich hier nichts erschleichen.
  if (!isAdmin) return <Navigate to="/" replace />;

  return (
    <div className="stack">
      <section>
        <p className="eyebrow">Verwaltung</p>
        <h1>Admin</h1>
      </section>

      <div className="tabs" role="tablist" aria-label="Admin-Bereiche">
        <button
          type="button"
          role="tab"
          className="tab"
          aria-selected={tab === 'users'}
          onClick={() => setTab('users')}
        >
          <Users size={15} aria-hidden="true" /> Benutzer
        </button>
        <button
          type="button"
          role="tab"
          className="tab"
          aria-selected={tab === 'announcements'}
          onClick={() => setTab('announcements')}
        >
          <Megaphone size={15} aria-hidden="true" /> Schwarzes Brett
        </button>
        <button
          type="button"
          role="tab"
          className="tab"
          aria-selected={tab === 'polls'}
          onClick={() => setTab('polls')}
        >
          <ListChecks size={15} aria-hidden="true" /> Abfragen
        </button>
      </div>

      {tab === 'users' ? <UsersPanel /> : tab === 'announcements' ? <AnnouncementsPanel /> : <PollsPanel />}
    </div>
  );
}
